// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { error } from 'react-notification-system-redux'
import { UNCAUGHT_ERROR } from 'errors'
import { ErrorsList } from 'components'

// err is an Error which has been thrown
// config allows you to override
// the default autoDismiss and title values
// as well as add your own configurations.

const errorErrorsList = (err, config) => dispatch => (
  dispatch(error({
    autoDismiss: 0,
    ...config,
    children: (
      <ErrorsList
        errors={err?.json?.errors || null}
        idRoot={'error-errors-list-error'}
        message={err?.message || UNCAUGHT_ERROR} />
    ),
  }))
)

export default errorErrorsList
